module.exports = __webpack_public_path__ + "img/lavendars_heart_drawing.2ff11a59.jpg";